<template>
    <div>

        <div class="apaympro-wrapper animated fadeIn container" style="width: 990px;"  v-if="checkCard">
            <div class="apaympro-page">

                <!-- Header -->
                <div class="apaympro-header mb-3">
                    <div class="page-info">
                        <h3 class="page-name mb-2" style="font-weight: 800; font-size: 1.6rem;">
                            Achat de cartes Visa prépayées
                        </h3>
                        <span class="text-muted">
                            <strong class="font-16">Acheter vos différentes cartes Visa ici !</strong> <br>
                            <p class="font-14">
                                Offrez-vous une ou plusieurs cartes Visa prépayées <br>
                                internationales hautement sécurisées pour vos <br>
                                achats en ligne, en magasin, vos voyages <br>  et bien plus.
                            </p>
                        </span>
                    </div>
                </div>
                <!-- Header -->

                <!-- Body -->
                <!-- **************** -->
                <!-- Choix des cartes -->
                <!-- **************** -->
                <div class="body mt-5">
                    <h4 class="box-title text-dark">Choisissez une ou plusieurs carte(s)</h4>
                    <div class="row">

                        <div class="col-lg-4 col-md-6 col-sm-6 col-xs-12 mb-5 pos-relative menu-cabine" v-for="carte in listeCartes" :key="carte.id">
                            <!-- content-overlay  -->
                            <div class="card border-0 shadow-md p-4 height-custom" style="border-radius: 1rem;">

                                <img src="../../assets/img/badge-check.png" alt="badge checked" width="32"
                                     class="show-selected-mode" v-if="carte.check == true"
                                >
                                <div :class="carte.check == true ? 'content shadow' : 'content'">
                                    <!--                                    <a href="javascript:;">-->
                                    <!-- Image de la carte -->
                                    <img class="rounded-lg content-image" :src="require(`../../assets/img/cartes/${carte.img}`)">
                                    <!-- Image de la carte -->
                                    <!--                                    </a>-->
                                </div>

                                <!-- Infos de la carte -->
                                <div class="line text-center">

                                    <h3 style="font-size: 1.2rem; font-weight: 800; line-height: 1.4; margin: 0 auto;" class="text-dark text-center pl-3 pr-3 pb-4">
                                        {{ tronqueText(carte.carte, 28) }}
                                    </h3>

                                    <div style="display: flex; flex-direction: column; font-weight: 800;">
                                        <span class="text-dark">
                                            {{
                                                new Intl.NumberFormat('fr-FR', { style: 'currency', currency: 'XOF' }).format( carte.montant )
                                            }}
                                        </span>
                                            <span class="text-dark mb-3">
                                            {{ carte.validite }}
                                        </span>
                                    </div>


                                    <!-- Bouton Choisir -->
                                    <button class="btn btn-dark btn-sm mr-2" type="button" @click="choisirCarte2(carte)"
                                            v-if="carte.check == false && carte.free == false" style="font-weight: bold">
                                        <i class="fas fa-check"></i>&nbsp; Choisir
                                    </button>
                                    <!-- Bouton Choisir -->

                                    <!-- Bouton Retirer -->
                                    <button class="btn btn-danger btn-sm mr-2" type="button" @click="choisirCarte2(carte)"
                                            v-if="carte.check == true" style="font-weight: bold">
                                        <i class="fas fa-minus"></i>&nbsp; Retirer
                                    </button>
                                    <!-- Bouton Retirer -->

                                    <!-- Bouton détails -->
                                    <button class="btn btn-light btn-sm" type="button" @click="voirDetails2(carte)"
                                            style="font-weight: bold">
                                        <i class="fas fa-search"></i>&nbsp; Détails
                                    </button>
                                    <!-- Bouton détails -->

                                    <p class="text-danger text-center font-12 mt-3" v-if="carte.carte == 'Carte Visa APAYM Pro'" style="margin: 0;">
                                        (Réservée aux marchands APAYM PRO)
                                    </p>

                                </div>
                                <!-- Infos de la carte -->

                            </div>
                        </div>
                    </div>
                </div>
                <!-- **************** -->
                <!-- Choix des cartes -->
                <!-- **************** -->
                <!-- Body -->


                <!-- Bouton de validation des cartes choisies -->
                <div class="floating-container" v-if=" cartesChoisis.length > 0 && checkCard">
                    <button type="button" class="btn bt-sm btn-dark custom-shadow" @click="validerLeChoixDesCartes">
                        <i class="fas fa-check"></i>&nbsp; Valider ma commande
                    </button>
                </div>
                <!-- Bouton de validation des cartes choisies -->

            </div>
        </div>

    </div>
</template>

<script>

    export default {
        components:{
        },
        data() {
            return {
            }
        },
        props: [ 'checkCard', 'cartesChoisis', 'validerCartes', 'listeCartes', 'choisirCarte', 'voirDetails' ],
        mounted(){
        },
        methods: {
            // Reload la page
            reload(){
                location.reload();
            },

            validerLeChoixDesCartes()
            {
                this.validerCartes();
            },

            choisirCarte2(carte)
            {
                this.choisirCarte(carte) ;
            },

            voirDetails2(carte)
            {
                this.voirDetails(carte);
            },

            tronqueText(text, nombreCharAtronquer)
            {
                let
                    delim = '...',
                    length = nombreCharAtronquer
                ;

                if( nombreCharAtronquer < text.length ) {

                    while ( (text[length] != " ") && (length > 0) ) {
                        length--;
                    }

                    if (length == 0) {
                        return text.substring(0, nombreCharAtronquer) + delim;
                    }

                    return text.substring(0, length) + delim;
                }

                return text;
            },
        },
    }
</script>

<style scoped>

    table { width:100%; }
    .intitule { font-weight:normal; color:#333;}

    .pos-relative{
        position: relative;
    }

    .pos-relative .line {
        position: relative;
        padding-top: 20px;
    }

    .pos-relative .line:after {
        content: "";
        position: absolute;
        left: 40%;
        width: 20%;
        height: 2px;
        background: #faaa13;
        top: 52px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 20px;
    }

    .pos-relative2{
        position: relative;
    }

    .pos-relative2 .line2 {
        position: relative;
        padding-top: 50px;
    }

    .pos-relative2 .line2:after {
        content: "";
        position: relative;
        left: 40%;
        width: 20%;
        height: 4px;
        background: #dfe2e5;
        top: 20px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
        /*border-radius: 20px;*/
    }

    .floating-container {
        position: fixed;
        width: auto;
        /* height: 100px; */
        bottom: 40px;
        right: 0;
        margin: 30px 25px;
        z-index: 20;
    }

    .custom-shadow{
        box-shadow: rgba(0, 0, 0, 0.09) 0px 2px 1px, rgba(0, 0, 0, 0.09) 0px 4px 2px, rgba(0, 0, 0, 0.09) 0px 8px 4px, rgba(0, 0, 0, 0.09) 0px 16px 8px, rgba(0, 0, 0, 0.09) 0px 32px 16px !important;
    }

    .content {
        position: relative;
        width: 100%;
        max-width: 400px;
        /*margin: auto;*/
        overflow: hidden;
    }

    .custom-rounded {
        border-radius: 32px;
    }

    .shadow{
        box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;
        border-radius: 20px;
    }

    .menu-cabine {
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
    }

    .menu-cabine:hover, .menu-cabine:focus{
        /* padding: 28px; */
        /* margin: 0 auto; */
        /*cursor: pointer;*/
        /* border-radius: 5px; */
        /* box-shadow: rgba(9, 30, 66, 0.25) 0px 4px 8px -2px, rgba(9, 30, 66, 0.08) 0px 0px 0px 1px; */
    }

    /*.content .content-overlay {*/
    /*    background: rgba(0,0,0,0.7);*/
    /*    position: absolute;*/
    /*    height: 100%;*/
    /*    width: 100%;*/
    /*    left: 0;*/
    /*    top: 0;*/
    /*    bottom: 0;*/
    /*    right: 0;*/
    /*    opacity: 0;*/
    /*    -webkit-transition: all 0.5s ease-in-out 0s;*/
    /*    -moz-transition: all 0.5s ease-in-out 0s;*/
    /*    transition: all 0.5s ease-in-out 0s;*/
    /*    border-radius: 14px;*/
    /*}*/

    /*.content:hover .content-overlay{*/
    /*    opacity: 1;*/
    /*}*/



    .content-overlay:hover{
        transition: all 0.3s;
        border-color: #faaa13;
        border-style: solid;
        border-width: 2px;
        /*padding: 8px;*/
        border-radius: 25px;
        /*box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px !important;*/
    }

    .content-image{
        width: 100%;
    }

    .content:hover .content-details{
        top: 50%;
        left: 50%;
        opacity: 1;
    }

    .content-details {
        position: absolute;
        text-align: center;
        padding-left: 1em;
        padding-right: 1em;
        width: 100%;
        top: 50%;
        left: 50%;
        opacity: 0;
        -webkit-transform: translate(-50%, -50%);
        -moz-transform: translate(-50%, -50%);
        transform: translate(-50%, -50%);
        -webkit-transition: all 0.3s ease-in-out 0s;
        -moz-transition: all 0.3s ease-in-out 0s;
        transition: all 0.3s ease-in-out 0s;
    }

    .fadeIn-top{
        top: 20%;
    }

    .content-details h3{
        color: #fff;
        font-weight: 500;
        letter-spacing: 0.15em;
        margin-bottom: 0.5em;
        text-transform: uppercase;
    }

    .content-details p{
        color: #fff;
        font-size: 0.8em;
    }

    .show-selected-mode{
        position: absolute;
        /*right: 3px;*/
        /*top: -6px;*/
        right: 17px;
        top: 18px;
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .show-selected-mode2{
        position: absolute;
        right: 3px;
        top: -9px;
        /*right: 20px;*/
        /*top: 8px;*/
        background: white;
        border-radius: 50%;
        z-index: 10;
    }

    .btn-disabled-custom {
        background: rgb(0 0 0 / 8%);
        border: rgb(0 0 0 / 8%);
        color: #1b1e21;
        cursor: not-allowed;
    }

    .mode-rechargement {
        display: flex;
        flex-direction: column;
        cursor: pointer;
    }

    .height-custom{
        height: 410px;
    }

    @media (max-width: 767px) {
        .show-selected-mode{
            right: 44px;
        }
    }

    @media (max-width: 991px) {

        .height-custom{
            height: 100%;
        }

        .content {
            width: 80%;
            margin: 0 auto;
        }
    }

    .searchIcon {
        margin-left: -35px;
        cursor: pointer;
        /* color: #261b64; */
        color: #343a40;
        cursor: pointer;
        font-size: 25px;
        z-index: 50;
    }

</style>